/**
 * Define all the .env file related keys
 */
const ENVIRONMENT = {
  PERSIST_KEY: process.env.REACT_APP_PERSIST_KEY,
  PERSIST_VERSION: process.env.REACT_APP_PERSIST_VERSION,
};
//
export default ENVIRONMENT;
